<template>
    <v-dialog v-model="dialog" max-width="1200" :fullscreen="testMode" persistent>
        <v-card>
            <v-card-title class="primary white--text title">
                {{ 'Rule'|translate }}
            </v-card-title>
            <v-card-text>
                <v-layout row>

                    <v-flex v-bind:class="[testMode ? 'xs4' : 'xs12']">
                        <v-form v-model="valid">
                            <v-text-field :label="'Title'|translate" autofocus
                                          v-model="activeItem.title" browser-autocomplete="off"
                                          v-bind:rules="fieldRules"></v-text-field>
                            <v-text-field :label="'Description'|translate" 
                                          v-model="activeItem.desc"></v-text-field>
                            <v-combobox
                                :items="topicSuggestions"
                                :label="'Topic'|translate"
                                v-model="activeItem.topic"
                                @change="handleTopicChange"
                            ></v-combobox>
                            <v-switch color="success"  :disabled="activeItem.topic==='equipment health'" v-model="activeItem.meta.kpiThresholdsActive"
                                      label="KPI Thresholds"
                                      ></v-switch>
                            <div v-if="activeItem.meta.kpiThresholdsActive">
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-card-title class="accent white--text subheading">
                                            {{ 'Health Gauge Steps'|translate }}
                                            <v-spacer></v-spacer>
                                            <v-icon class="mr-2" small @click="addKpiStep">fa-plus</v-icon>
                                        </v-card-title>
                                    </v-flex>
                                    <v-flex xx12 v-for="(step, stepindex) in activeItem.meta.kpiThresholds">
                                        <v-layout row>
                                            <v-flex xs2 class="pa-2">
                                                <v-text-field v-model.number="step.range[0]" type="number"
                                                              :label="'Min'|translate"></v-text-field>
                                            </v-flex>
                                            <v-flex xs2 class="pa-2">
                                                <v-text-field v-model.number="step.range[1]" type="number"
                                                              :label="'Max'|translate"></v-text-field>
                                            </v-flex>
                                            <v-flex xs2 class="pa-2">
                                                <v-text-field v-model="step.color" type="text"
                                                              :label="'Color'|translate">
                                                    <template v-slot:prepend>
                                                        <v-icon v-show="step.color" v-bind:style="{ color: step.color }">fa-tint</v-icon>
                                                    </template>

                                                </v-text-field>
                                            </v-flex>
                                            <v-flex xs3 class="pa-2">
                                                <v-text-field v-model="step.status" type="text"
                                                              :label="'Status'|translate"></v-text-field>
                                            </v-flex>
                                            <v-flex xs2 class="pa-2">
                                                <severity-selector v-model="step.severity"
                                                                   :label="'Severity'|translate"></severity-selector>
                                            </v-flex>
                                            <v-flex xs1 class="pa-2">
                                                <v-icon small class="mt-4" @click="removeKpiStep(stepindex)">fa-trash</v-icon>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>

                            </div>
                            <v-radio-group v-model="activeItem.active_status" :mandatory="true"
                                           :label="'Active Status'|translate">
                                <v-radio :label="'Active - rule will be applied'|translate" :value="'active'"></v-radio>
                                <v-radio :label="'Inactive - rule will not run'|translate"
                                         :value="'inactive'"></v-radio>
                                <v-radio
                                    :label="'Muted - rules will be applied, but notifications (if any) will immediately be acknowledged'|translate"
                                    :value="'muted'"></v-radio>
                            </v-radio-group>
                            <v-combobox
                                :items="possibleEquipTypes"
                                :label="'Equipment Group'|translate"
                                v-model="activeItem.equipment_group"
                            ></v-combobox>
                            <v-text-field :label="'Rule'|translate"  v-model="activeItem.rule">
                                <template v-slot:append>
                                    <v-icon v-on:click="openRuleBuilder" class="cursor-as-pointer">fa-caret-down</v-icon>
                                </template>
                            </v-text-field>
                            <v-dialog v-model="ruleBuilderDialog" max-width="900"  persistent>
                                <v-card v-if="ruleBuilderDialog">
                                    <v-card-title class="primary white--text title">
                                        {{ 'Rule builder'|translate }}
                                        <v-spacer></v-spacer>
                                        <v-icon class="mr-2" small @click="addRulePart">fa-plus</v-icon>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-layout row wrap>
                                            <v-flex xs12 v-for="(part,index) in ruleBuilderParts">
                                                <v-layout row>
                                                    <v-flex xs2 class="pa-2">
                                                        <v-select :label="'Function'|translate" :items="ruleBuilderFunctions"
                                                                      v-model="part.calcFunc"></v-select>
                                                    </v-flex>
                                                    <v-flex xs5 class="pa-2">
                                                        <v-text-field :label="'Series'|translate"
                                                                      v-model="part.series"></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs2 class="pa-2">
                                                        <v-text-field :label="'Observations'|translate"
                                                                      v-model.number="part.number_of_observations"></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs2 class="pa-2">
                                                        <v-text-field :label="'Threshold'|translate"
                                                                      v-model.number="part.threshold"></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs1 class="pa-2">
                                                        <v-icon small class="ml-4 mt-4" @click="removeBuilderPart(index)">fa-trash</v-icon>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                    <v-card-actions>

                                        <div style="width:240px;" class="ml-3">
                                            <v-select :label="'Available sensors'|translate" :items="possibleSensorNames"
                                                      v-model="ruleBuilderSensor"></v-select>
                                        </div>

                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }" >
                                                <v-btn icon class="primary ml-2 mr-2" @click="copyClipText(ruleBuilderSensor)" :disabled="!ruleBuilderSensor||ruleBuilderSensor===''" v-on="on">
                                                    <v-icon>
                                                        fa-copy
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>{{'Copy to clipboard'|translate}}</span>
                                        </v-tooltip>
                                        <v-spacer></v-spacer>
                                        <div style="width:80px;">
                                        <v-select :label="'Operation'|translate" :items="ruleBuilderLogicOps"
                                                  v-model="ruleBuilderLogicOp"></v-select>
                                        </div>
                                        <v-btn class="primary ml-2" @click="useAsRule" :disabled="ruleBuilderParts.length<1">
                                            {{ 'Use as rule'|translate }}
                                        </v-btn>
                                        <v-btn @click="ruleBuilderDialog=false">{{ 'Cancel'|translate }}</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                            <div v-if="usedParams&&usedParams.length>0">
                                {{ 'Used parameters'|translate }}
                                <ul>
                                    <li v-for="param in usedParams">
                                        {{ param.parameter_name }} : {{ param.parameter_value }}
                                        <v-icon
                                            small
                                            class="ml-2"
                                            v-if="$can('update', 'Parameter')"
                                            @click="$can('update', 'Parameter') && editParam(param)"
                                        >
                                            fa-edit
                                        </v-icon>
                                    </li>
                                </ul>
                                <parameter-record-dialog v-model="paramDialog" :item="editedParam"
                                                         v-on:doreload="refreshpoints()"></parameter-record-dialog>
                            </div>
                            <v-radio-group v-model="activeItem.on" :mandatory="true">
                                <v-radio :label="'Rule Active when Equipment On'|translate" :value="true"
                                         color="green"></v-radio>
                                <v-radio :label="'Rule Active when Equipment Off'|translate" :value="false"
                                         color="yellow"></v-radio>
                                <v-radio :label="'Rule Active Anytime'|translate" :value="null"></v-radio>
                            </v-radio-group>
                            <severity-selector v-model="activeItem.severity"
                                               :label="'Severity'|translate"></severity-selector>
                            <v-text-field :label="'Relevant Variables'|translate" 
                                          v-model="activeItem.relevant_variables"></v-text-field>
                            <custom-view-selector v-model="activeItem.meta.custom_view" clearable
                                                ></custom-view-selector>
                            <v-textarea
                                :label="'Recommended Action'|translate"
                                v-model="activeItem.recommended_actions"
                                auto-grow
                            ></v-textarea>
                            <v-text-field :label="'Value'|translate" 
                                          v-model="activeItem.value"></v-text-field>
                            <v-text-field :label="'Cost'|translate" v-model="activeItem.cost"></v-text-field>
                        </v-form>
                    </v-flex>

                    <v-flex xs8 v-if="testMode" class="pl-5">
                        <date-range-selector v-model="range"></date-range-selector>
                        <equipment-selector v-model="equip"
                                            :typeFilter="activeItem.equipment_group"></equipment-selector>
                        <v-btn class="accent" @click="runTest()">{{ 'Run test'|translate }}</v-btn>
                        <v-progress-linear v-show="loading" :indeterminate="true"></v-progress-linear>
                        <div v-if="showData&&!loading">
                            <fault-eval-widget
                                :rule="activeItem.rule"
                                :title="activeItem.title"
                                :value="activeItem.value"
                                :cost="activeItem.cost"
                                :equipment-name="equip"
                                :relevant-variables="activeItem.relevant_variables"
                                :on-only="activeItem.on"
                                show-cost
                                :date-range="range"></fault-eval-widget>
                        </div>

                    </v-flex>
                </v-layout>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary" @click="addRecord(true)" :disabled="!valid||!$can('update', 'Rule')">
                    {{ 'Save'|translate }}
                </v-btn>
                <v-btn class="accent" @click="testMode=true" v-show="!testMode">{{ 'Test the rule'|translate }}</v-btn>
                <v-btn class="accent" @click="testMode=false" v-show="testMode">
                    {{ 'Close testing interface'|translate }}
                </v-btn>
                <v-btn @click="dialog=false">{{ 'Cancel'|translate }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {putRule} from '../../helper'
import SeveritySelector from "../SeveritySelector";
import ParameterRecordDialog from "../parameter/ParameterRecordDialog";
import DateRangeSelector from "../DateRangeSelector";
import EquipmentSelector from "../EquipmentSelector";
import moment from 'moment'
import FaultEvalWidget from "../widgets/FaultEvalWidget";
import CustomViewSelector from "../CustomViewSelector";

export default {
    props: {
        value: {type: Boolean, default: true},
        item: {type: Object, default: null},
        parameter: {type: Array, default: []}
    },
    components: {SeveritySelector, ParameterRecordDialog, DateRangeSelector, EquipmentSelector, FaultEvalWidget,CustomViewSelector},
    computed: {
        usedParams() {
            if (!this.activeItem.rule || this.activeItem.rule == '') {
                return []
            } else {
                let used = [];
                for (let param of this.parameter) {
                    if (this.activeItem.rule.indexOf(param.parameter_name) > -1) {
                        used.push(param)
                    }
                }
                return used;
            }
        },
        possibleEquipTypes(){
            return [...new Set(this.combinations.map(x=>x.equipment_type))].sort()
        },
        possibleSensorNames(){
            if (this.activeItem.equipment_group&&this.activeItem.equipment_group!==""){
                return [...new Set(this.combinations.filter(x=>x.equipment_type===this.activeItem.equipment_group).map(x=>x.sensor_name))].sort()
            }
            return [...new Set(this.combinations.map(x=>x.sensor_name))].sort()

        }
    },
    watch: {
        item(item) {
            this.initializeVar()
            if (item) {
                if (item.severity) {
                    item.severity = item.severity.toLowerCase()
                }
                this.activeItem = this.item
                if (!this.activeItem.active_status) {
                    this.activeItem.active_status = 'active'
                }
                if (!this.activeItem.meta) {
                    this.$set(this.activeItem, "meta", {
                        kpiThresholdsActive:false
                    })
                }
                if (!this.activeItem.meta.kpiThresholds) {
                    this.$set(this.activeItem.meta, "kpiThresholds", [
                        {
                            "range": [
                                0,
                                100
                            ],
                            "color": "#00CF27",
                            "status": "Normal",
                            "severity":"info",
                        },
                        {
                            "range": [
                                100,
                                200
                            ],
                            "color": "#FDA20A",
                            "status": "Warning",
                            "severity":"info",
                        }
                    ])
                }
                if (this.activeItem.topic==="equipment health"){
                    this.activeItem.meta.kpiThresholdsActive=true
                }
            }
        },
        value() {
            if (this.dialog != this.value) {
                this.dialog = this.value
            }
        },
        dialog() {
            this.$emit('input', this.dialog)
            if (!this.item) {
                this.initializeVar()
            }
        }
    },
    mounted(){
        let combinations=this.$store.state.pointsListStore.pointsList.points_list.map(sensor=>{return{
            sensor_name:sensor.sensor_name,
            equipment_name:sensor.equipment_name,
            equipment_type:this.$store.state.pointsListStore.pointsList.equipment_details[sensor.equipment_name].equipment_type,
            equipment_tags:this.$store.state.pointsListStore.pointsList.equipment_details[sensor.equipment_name].equipment_tags ? this.$store.state.pointsListStore.pointsList.equipment_details[sensor.equipment_name].equipment_tags : [],
            floor:this.$store.state.pointsListStore.pointsList.equipment_details[sensor.equipment_name].floor,
        }})
        if (this.$store.state.userStore.user.content.role!=="admin"){
            combinations=combinations.filter(x=>!x.floor||!x.floor.startsWith("."))
        }
        this.combinations=JSON.parse(JSON.stringify(combinations))
    },
    beforeMount() {
        let maxDate = this.$store.state.pointsListStore.pointsList.data_max_date;
        if (maxDate) {
            this.range = {
                start: moment(maxDate).subtract(30, "days").format('YYYY-MM-DD'),
                end: moment(maxDate).format('YYYY-MM-DD')
            }
        }
    },
    data() {
        return {
            dialog: false,
            combinations:[],
            topicSuggestions:['sensor', 'maintenance', 'control logic', 'energy', 'operation','equipment health'],
            equip: null,
            valid: false,
            range: {start: moment().subtract(30, "days").format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD')},
            fieldRules: [value => !!value || 'This value is required.', v => v.length < 100 || 'This value cannot be longer than 100 characters.'],
            showData: false,
            testMode: false,
            paramDialog: false,
            ruleBuilderDialog: false,
            ruleBuilderSensor: null,
            ruleBuilderParts: [
                {
                    calcFunc:"is_exceed",
                    series:null,
                    number_of_observations:4,
                    threshold:10
                }
            ],
            ruleBuilderLogicOp:" & ",
            ruleBuilderLogicOps: [
                {
                    text: "AND",
                    value: " & "
                },
                {
                    text: "OR",
                    value: " | "
                }
            ],
            ruleBuilderFunctions: [
                {
                    text: "Is Exceeded",
                    value: "is_exceed"
                },
                {
                    text: "Is Below",
                    value: "is_below"
                },
                {
                    text: "Is Flatline",
                    value: "is_flatline"
                },
                {
                    text: "Is Shortcycling",
                    value: "is_shortcycling"
                }
            ],
            loading: false,
            editedParam: null,
            activeItem: {
                desc: '',
                title: '',
                equipment_group: '',
                rule: '',
                on: true,
                value: '',
                cost: '',
                severity: 'low',
                topic: 'default',
                active_status: 'active',
                relevant_variables: '',
                recommended_actions: '',
                rule_id: null,
                meta: {
                    kpiThresholdsActive:false,
                    kpiThresholds: [
                        {
                            "range": [
                                0,
                                100
                            ],
                            "color": "#00CF27",
                            "status": "Normal",
                            "severity":"info",
                        },
                        {
                            "range": [
                                100,
                                200
                            ],
                            "color": "#FDA20A",
                            "status": "Warning",
                            "severity":"info",
                        }
                    ]
                }
            },
        }
    },
    methods: {
        copyClipText(text){
            this.$copyText('df["'+text+'"]')
        },
        removeBuilderPart(index){
            this.ruleBuilderParts.splice(index, 1)
        },
        openRuleBuilder(){
            this.ruleBuilderParts=[
                {
                    calcFunc:"is_exceed",
                    series:null,
                    number_of_observations:4,
                    threshold:10
                }
            ]
            this.ruleBuilderDialog=true
        },
        useAsRule(){
            this.activeItem.rule=this.ruleBuilderParts.map(x=>x.calcFunc+"("+x.series+","+x.number_of_observations+","+x.threshold+")").join(this.ruleBuilderLogicOp)
            this.ruleBuilderDialog=false
        },
        addRulePart(){
            this.ruleBuilderParts.push({
                calcFunc:"is_exceed",
                series:null,
                number_of_observations:4,
                threshold:10
            })
        },
        handleTopicChange(value){
            if(value){
                this.activeItem.meta.kpiThresholdsActive=true
            }
        },
        addKpiStep() {
            this.activeItem.meta.kpiThresholds.push({range: [0, 1], color: 'gray', status:"","severity":"info"})
        },
        removeKpiStep(stepindex) {
            this.activeItem.meta.kpiThresholds.splice(stepindex, 1)
        },
        refreshpoints() {
            this.$emit('refreshpoints')
        },
        runTest() {
            let me = this;
            me.loading = true
            me.showData = false
            setTimeout(function () {
                me.showData = true;
                me.loading = false;
            }, 100)
        },
        editParam(param) {
            this.editedParam = Object.assign({}, param)
            this.paramDialog = true
        },
        initializeVar(close) {
            this.testMode = false
            this.loading = false
            this.equip = null
            this.showData = false

            this.activeItem = {
                desc: '',
                title: '',
                equipment_group: '',
                rule: '',
                on: true,
                value: '',
                cost: '',
                severity: 'low',
                topic: 'default',
                active_status: 'active',
                relevant_variables: '',
                recommended_actions: '',
                rule_id: null,
                meta: {
                    kpiThresholdsActive:false,
                    kpiThresholds: [
                        {
                            "range": [
                                0,
                                100
                            ],
                            "color": "#00CF27",
                            "status": "Normal",
                            "severity":"info",
                        },
                        {
                            "range": [
                                100,
                                200
                            ],
                            "color": "#FDA20A",
                            "status": "Warning",
                            "severity":"info",
                        }
                    ]
                }
            }
            if (close) {
                this.dialog = false;
            }
        },
        async addRecord(close) {
            await putRule(
                {
                    'rule_id': this.activeItem.rule_id,
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'desc': this.activeItem.desc,
                    'title': this.activeItem.title,
                    'equipment_group': this.activeItem.equipment_group,
                    'rule': this.activeItem.rule,
                    'on': this.activeItem.on,
                    'topic': this.activeItem.topic,
                    'active_status': this.activeItem.active_status,
                    'value': this.activeItem.value,
                    'severity': this.activeItem.severity,
                    'relevant_variables': this.activeItem.relevant_variables,
                    'recommended_actions': this.activeItem.recommended_actions,
                    'cost': this.activeItem.cost,
                    'meta': this.activeItem.meta
                }
            )
            this.$emit('doreload')
            if (close) {
                this.dialog = false;
            }
        }
    },
    name: 'RuleRecordDialog'
}
</script>

<style scoped>

</style>
